import { defineStore } from "pinia";
import { ref } from "vue";
import type { accountType } from "../service/account/types";

export const useAccountTypesStore = defineStore(
  "accountTypes",
  () => {
    const accountTypes = ref<accountType[]>([]);

    function setAccountTypes(types: accountType[]) {
      accountTypes.value = types;
    }

    function clearAccountTypes() {
      accountTypes.value = [];
    }

    function getAccountTypes(): accountType[] {
      return accountTypes.value;
    }

    return {
      accountTypes,
      setAccountTypes,
      clearAccountTypes,
      getAccountTypes,
    };
  },
  {
    persist: true,
  }
);
